const infoToastConfig = (toastMessage, variant, timeout = 1500) => {
  return {
    toastMessage: toastMessage,
    actionText: "",
    actionCallback: () => {},
    variant: variant,
    position: "top",
    align: "center",
    dismissible: true,
    light: false,
    timeout: timeout,
    inline: false,
    autoDismiss: true,
  };
};

export default infoToastConfig;
